import React from 'react';

const Footer = () => {
    return (
        <div className="container-fluid bg-dark text-light footer pt-5 wow fadeIn" data-wow-delay="0.1s" id="contact">
            <div className="container py-5">
                <div className="row g-5">
                    <div className="col-lg-3 col-md-6">
                        <h4 className="text-white mb-3">Useful Links</h4>
                        <a className="btn btn-link" href="http://www.infocom.tn/">Ministry of Communication Technologies</a>
                        <a className="btn btn-link" href="http://www.bawaba.gov.tn/">Tunisian Government Portal</a>
                        <a className="btn btn-link" href="https://www.ati.tn/">Tunisian Internet Agency</a>
                        <a className="btn btn-link" href="https://www.certification.tn/">National Agency for Electronic Certification</a>
                        <a className="btn btn-link" href="https://www.ansi.tn/">National Agency for Cyber Security</a>
                        <a className="btn btn-link" href="https://www.tunisietelecom.tn/particulier/">Tunisie Télécom (Tunisian Telecom)</a>
                        <a className="btn btn-link" href="http://www.poste.tn/">Tunisian Post</a>
                        <a className="btn btn-link" href="http://www.smartunisia.tn/">Tunisian Post</a>
                        <a className="btn btn-link" href="https://data.gov.tn/fr/">Open Data</a>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h4 className="text-white mb-3">Contact</h4>
                        <p className="mb-2"><i className="fa fa-home me-3"></i>Centre National de l’Informatique</p>
                        <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>17, rue Belhassen Ben Chaabane, 1005 El Omrane, Tunis Tunisie.</p>
                        <p className="mb-2"><i className="fa fa-phone-alt me-3"></i>tel: +216 71 783 055</p>
                        <p className="mb-2"><i className="fa fa-fax me-3"></i>fax: + 216 71 781 862</p>
                        <p className="mb-2"><i className="fa fa-envelope me-3"></i>mail:webcni@cni.tn</p>
                        <p className="mb-2"><i className="fa fa-globe me-3"></i>website : http://www.cni.tn</p>
                        <p className="mb-2"><i className="fa fa-qrcode me-3"></i>Qrcode </p>
                        <img className="w-10" src="../assetsTemplates/template1/img/qrcode.jpg" alt="QR Code Image"/>



                        <div className="d-flex pt-2">
                            <a className="btn btn-outline-light btn-social" href="https://twitter.com/CNITUNISIA"><i className="fab fa-twitter"></i></a>
                            <a className="btn btn-outline-light btn-social" href="https://www.facebook.com/CNITUNISIA"><i className="fab fa-facebook-f"></i></a>
                            <a className="btn btn-outline-light btn-social" href="https://workspace.google.com/blog/product-announcements/what-you-need-to-know-about-the-sunset-of-consumer-google-plus-on-april-second?hl=en"><i className="fab fa-google"></i></a>
                            <a className="btn btn-outline-light btn-social" href="https://www.linkedin.com/in/cnitunisia"><i className="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h4 className="text-white mb-3">Certification ISO</h4>
                        <div className="row g-2 pt-2">
                            <div className="col-4">
                                <img className="img-fluid bg-light p-1" src="../assetsTemplates/template1/img/isoarmax.jpg" alt="" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid bg-light p-1" src="../assetsTemplates/template1/img/isofrmax.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h4 className="text-white mb-3">More photos in this album</h4>
                        <div className="row g-2 pt-2">
                            <div className="col-4">
                                <img className="img-fluid bg-light p-1" src="../assetsTemplates/template1/img/img4.jpg" alt="" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid bg-light p-1" src="../assetsTemplates/template1/img/img2.jpg" alt="" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid bg-light p-1" src="../assetsTemplates/template1/img/img3.jpg" alt="" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid bg-light p-1" src="../assetsTemplates/template1/img/img1.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="copyright">
                    <div className="row">
                        <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                            &copy; <a className="border-bottom" href="https://cnidemo.vercel.app/">https://cnidemo.vercel.app/</a>, All Right Reserved By Yasser Ben Ouhiba.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
